import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: [],
  isLoggedIn: false,
};

export const liveClassRecordingsReducer = createReducer(initialState, {
  [types.LIVE_CLASS_RECORDINGS](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LIVE_CLASS_RECORDINGS_PLAYER](state, action) {
    return {
      ...state,
      liveClassRecordingsPlayer: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
